// 🔒 AUTORIZACION-REMOTA-2026-11-03 — cuántas solicitudes esperan autorización (insignia del menú y aviso al entrar).
// Pregunta al servidor cada 30 s mientras el usuario está dentro. Sin el permiso «Autorizar remoto» el servidor
// responde allowed=false y se deja de preguntar.
import { useState, useEffect } from 'react';
import { remoteAuthAPI } from '@/lib/api';

export function useAutorizacionesPendientes(intervalo = 30000) {
  const [estado, setEstado] = useState({ allowed: false, count: 0, listo: false });
  useEffect(() => {
    let vivo = true;
    let t = null;
    const leer = async () => {
      try {
        const r = await remoteAuthAPI.pendingCount();
        if (!vivo) return;
        const allowed = r?.data?.allowed === true;
        setEstado({ allowed, count: Number(r?.data?.count) || 0, listo: true });
        if (allowed) t = setTimeout(leer, intervalo);
      } catch {
        if (vivo) t = setTimeout(leer, intervalo);
      }
    };
    leer();
    return () => { vivo = false; clearTimeout(t); };
  }, [intervalo]);
  return estado;
}
